/* @flow */
import AddGroupOwnerModal from './AddGroupOwnerModal.jsx';
import Button from 'components/Button.jsx';
import ConfirmDialog from 'components/ConfirmDialog.jsx';
import CurrentUser from 'auth/CurrentUser';
import Group from 'entities/Group';
import GroupActions from 'groups/actions/GroupActions';
import GroupMemberListItem from './GroupMemberListItem.jsx';
import GroupMembership from 'entities/GroupMembership';
import GroupMembershipStore from 'stores/GroupMembershipStore';
import Link from 'components/Link.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import React from 'react';
import ScrollableArea from 'components/ScrollableArea.jsx';
import Text from 'components/Text.jsx';
import ToastActions from 'actions/ToastActions';
import linkStateWithStores from 'components/mixins/linkStateWithStores';

import './styles/GroupMemberList.scss';

const GroupMemberList = React.createClass({
  propTypes: {
    group: React.PropTypes.instanceOf(Group).isRequired,
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  mixins: [
    // XXX refresh whenever GroupMembershipStore dispatches
    linkStateWithStores([GroupMembershipStore]),
  ],

  getInitialState() {
    return this.getStateFromStores();
  },

  getStateFromStores() {
    const { group } = this.props;
    return {
      owners: group.getOwners(),
    };
  },

  getAddOwnerModal() {
    return <AddGroupOwnerModal group={this.props.group} />;
  },

  renderClassOwner(member: GroupMembership) {
    return (
      <GroupMemberListItem
        key={member.id}
        className="GroupMemberList-listItem"
        classMember={member}
        owner={member.isOwner()}
      />
    );
  },

  renderConfirmResignationDialog() {
    const onConfirm = () => {
      this.props.onRequestHide();
      GroupActions.resignOwnership(this.props.group).then(() => {
        ToastActions.showSuccessToast('Removed as class owner.');
        this.context.router.push('/classes');
      }, () => {
        ToastActions.showDefaultErrorToast();
      });
    };

    return (
      <ConfirmDialog
        eventScreenName="GroupMemberList"
        title="Are you sure you want to remove yourself as class owner?"
        subtext="Once you remove yourself as class owner, another owner will need to add you again."
        actionButtonText="Remove"
        cancelButtonText="Cancel"
        onConfirm={onConfirm}
      />
    );
  },

  renderAddOwnerLink() {
    return (
      <li className="GroupMemberListItem">
        <ModalTrigger modal={this.getAddOwnerModal()}>
          <Link
            className="GroupMemberListItem-addOwnerLink"
            eventElementName="GroupMemberListItem-addOwnerLink">
            <Text weight="semibold">
              Add class owner
            </Text>
          </Link>
        </ModalTrigger>
      </li>
    );
  },

  renderFooter() {
    const userId = CurrentUser.getUser().id;
    const { group } = this.props;
    const isOwner = group.isOwnedByUser(userId);

    return (
      isOwner &&
        this.state.owners.length > 1 &&
        <div className="GroupMemberList-footer">
          <ModalTrigger modal={this.renderConfirmResignationDialog()}>
            <Button
              className="GroupMemberList-resignButton"
              level="secondary"
              color="lava"
              size="small"
              eventElementName="GroupMemberList-resignButton">
              Remove me as class owner
            </Button>
          </ModalTrigger>
        </div>
    );
  },

  renderClassOwners() {
    return (
      <ScrollableArea>
        <ul className="GroupMemberList-list">
          {this.state.owners.map(this.renderClassOwner)}
          {this.renderAddOwnerLink()}
        </ul>
      </ScrollableArea>
    );
  },

  render() {
    return (
      <div className="GroupMemberList">
        {this.renderClassOwners()}
        {this.renderFooter()}
      </div>
    );
  },
});

export default GroupMemberList;



// WEBPACK FOOTER //
// ./src/groups/components/GroupMemberList.jsx